export const translations = {
  it: {
    // Header
    nav: {
      home: 'Home',
      about: 'Chi Siamo',
      services: 'Servizi',
      resources: 'Risorse',
      contact: 'Contatti',
      quote: 'Richiedi Preventivo'
    },
    
    // Home Page
    home: {
      heroTitle: 'Certificazioni ISO e Conformità HSE',
      heroSubtitle: 'Partner di fiducia per la certificazione ISO 9001, ISO 45001, ISO 14001 e conformità HSE a La Spezia, Firenze, Milano, Verona, Bologna e Roma',
      requestQuote: 'Richiedi Preventivo',
      discoverServices: 'Scopri i Servizi',
      stats: {
        companies: 'Aziende Certificate',
        years: 'Anni di Esperienza',
        success: 'Successo Certificazioni'
      },
      servicesTitle: 'I Nostri Servizi',
      servicesSubtitle: 'Consulenza completa per la certificazione e la conformità normativa',
      whyTitle: 'Perché Scegliere Mallorie Consulting',
      whySubtitle: 'La tua partnership strategica per il successo certificativo',
      coverageTitle: 'Copertura Territoriale',
      coverageSubtitle: 'Operiamo nelle principali regioni italiane con presenza locale e supporto dedicato',
      testimonialsTitle: 'Cosa Dicono i Nostri Clienti',
      testimonialsSubtitle: 'La fiducia dei nostri clienti è la nostra migliore referenza',
      ctaTitle: 'Pronto per la Certificazione?',
      ctaSubtitle: 'Contattaci oggi per una consulenza gratuita e scopri come possiamo aiutarti a ottenere la certificazione ISO',
      ctaButton: 'Richiedi Preventivo Gratuito',
      ctaContact: 'Contattaci'
    },
    
    // Services
    services: {
      title: 'I Nostri Servizi',
      subtitle: 'Consulenza specializzata per certificazioni ISO e conformità HSE',
      learnMore: 'Scopri di più',
      processTitle: 'Il Nostro Processo',
      processSubtitle: 'Un approccio strutturato per garantire il successo della certificazione',
      steps: [
        { title: 'Analisi Iniziale', desc: 'Valutiamo lo stato attuale della vostra organizzazione e identifichiamo le aree di intervento' },
        { title: 'Pianificazione', desc: 'Sviluppiamo un piano d\'azione dettagliato con tempistiche e milestone chiare' },
        { title: 'Implementazione', desc: 'Vi supportiamo nell\'implementazione dei sistemi e nella formazione del personale' },
        { title: 'Audit Interno', desc: 'Conduciamo audit interni per verificare la conformità e preparare alla certificazione' },
        { title: 'Certificazione', desc: 'Vi accompagniamo durante l\'audit di certificazione dell\'ente certificatore' },
        { title: 'Supporto Continuo', desc: 'Assistenza continua per il mantenimento e il miglioramento del sistema' }
      ],
      ctaTitle: 'Inizia il Tuo Percorso di Certificazione',
      ctaSubtitle: 'Richiedi un preventivo personalizzato o contattaci per maggiori informazioni'
    },
    
    // Resources/Blog
    resources: {
      title: 'Risorse e Blog',
      subtitle: 'Guide, articoli e risorse utili sulla certificazione ISO e conformità HSE',
      search: 'Cerca articoli...',
      all: 'Tutti',
      readArticle: 'Leggi l\'articolo',
      noResults: 'Nessun articolo trovato. Prova con un altro termine di ricerca.',
      faqTitle: 'Domande Frequenti',
      faqSubtitle: 'Le risposte alle domande più comuni sulla certificazione ISO',
      ctaTitle: 'Hai Altre Domande?',
      ctaSubtitle: 'Il nostro team è pronto a rispondere a tutte le tue domande sulla certificazione ISO'
    },
    
    // Contact
    contact: {
      title: 'Contattaci',
      subtitle: 'Siamo qui per rispondere a tutte le tue domande sulla certificazione ISO e conformità HSE',
      formTitle: 'Inviaci un Messaggio',
      name: 'Nome e Cognome',
      email: 'Email',
      phone: 'Telefono',
      subject: 'Oggetto',
      message: 'Messaggio',
      selectSubject: 'Seleziona un oggetto',
      send: 'Invia Messaggio',
      sending: 'Invio in corso...',
      subjects: {
        general: 'Informazioni Generali',
        iso9001: 'Certificazione ISO 9001',
        iso45001: 'Certificazione ISO 45001',
        iso14001: 'Certificazione ISO 14001',
        hse: 'Conformità HSE',
        quote: 'Richiesta Preventivo',
        other: 'Altro'
      },
      infoTitle: 'Informazioni di Contatto',
      emailLabel: 'Email',
      phoneOffice: 'Telefono Ufficio',
      phoneSales: 'Vendite / Commerciale',
      addressLabel: 'Sede Principale',
      hoursLabel: 'Orari di Ufficio',
      hours: 'Lun - Ven: 9:00 - 18:00\nSab - Dom: Chiuso',
      serviceAreasTitle: 'Aree di Servizio',
      serviceAreasDesc: 'Operiamo nelle seguenti regioni con supporto locale dedicato:'
    },
    
    // Quote Request
    quote: {
      title: 'Richiedi un Preventivo',
      subtitle: 'Compila il form per ricevere un preventivo personalizzato entro 48 ore',
      companyInfo: 'Informazioni Aziendali',
      companyName: 'Nome Azienda',
      industry: 'Settore',
      selectIndustry: 'Seleziona settore',
      companySize: 'Dimensione Aziendale',
      selectSize: 'Seleziona dimensione',
      timeline: 'Tempistiche Desiderate',
      selectTimeline: 'Seleziona tempistica',
      contactInfo: 'Dati di Contatto',
      name: 'Nome e Cognome',
      email: 'Email',
      phone: 'Telefono',
      servicesInterest: 'Servizi di Interesse',
      additionalInfo: 'Informazioni Aggiuntive',
      describe: 'Descrivi le tue esigenze',
      submit: 'Richiedi Preventivo Gratuito',
      submitting: 'Invio in corso...',
      note: 'Riceverai una risposta personalizzata entro 48 ore',
      whatHappens: 'Cosa Succede Dopo?',
      helpTitle: 'Hai Bisogno di Aiuto?',
      helpDesc: 'Se preferisci parlare direttamente con noi, siamo disponibili:',
      office: 'Ufficio',
      sales: 'Vendite',
      industries: {
        manufacturing: 'Manifatturiero',
        construction: 'Edilizia',
        logistics: 'Logistica',
        services: 'Servizi',
        healthcare: 'Sanità',
        food: 'Alimentare',
        other: 'Altro'
      },
      sizes: {
        '1-10': '1-10 dipendenti',
        '11-50': '11-50 dipendenti',
        '51-250': '51-250 dipendenti',
        '251-500': '251-500 dipendenti',
        '500+': '500+ dipendenti'
      },
      timelines: {
        urgent: 'Entro 3 mesi',
        normal: '3-6 mesi',
        flexible: '6-12 mesi',
        exploring: 'Sto valutando'
      },
      placeholders: {
        company: 'La tua azienda',
        name: 'Il tuo nome',
        email: 'email@azienda.it',
        phone: '+39 123 456 7890'
      }
    },
    
    // Footer
    footer: {
      tagline: 'Eccellenza nella Consulenza ISO e HSE',
      servicesTitle: 'Servizi',
      resourcesTitle: 'Risorse',
      contactTitle: 'Contatti',
      blogArticles: 'Blog e Articoli',
      guideFaq: 'Guide e FAQ',
      requestQuote: 'Richiedi Preventivo',
      contactUs: 'Contattaci',
      office: 'Ufficio',
      salesLabel: 'Vendite',
      copyright: '© {year} Mallorie Consulting Group. Tutti i diritti riservati.',
      privacy: 'Privacy Policy',
      terms: 'Termini e Condizioni'
    },
    
    // Common
    common: {
      required: '*',
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      readMore: 'Leggi di più',
      learnMore: 'Scopri di più',
      contactUs: 'Contattaci',
      requestQuote: 'Richiedi Preventivo'
    }
  },
  
  en: {
    // Header
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      resources: 'Resources',
      contact: 'Contact',
      quote: 'Request Quote'
    },
    
    // Home Page
    home: {
      heroTitle: 'ISO Certifications & HSE Compliance',
      heroSubtitle: 'Trusted partner for ISO 9001, ISO 45001, ISO 14001 certification and HSE compliance in La Spezia, Florence, Milan, Verona, Bologna and Rome',
      requestQuote: 'Request Quote',
      discoverServices: 'Discover Services',
      stats: {
        companies: 'Certified Companies',
        years: 'Years of Experience',
        success: 'Certification Success'
      },
      servicesTitle: 'Our Services',
      servicesSubtitle: 'Complete consulting for certification and regulatory compliance',
      whyTitle: 'Why Choose Mallorie Consulting',
      whySubtitle: 'Your strategic partnership for certification success',
      coverageTitle: 'Service Coverage',
      coverageSubtitle: 'We operate in key Italian regions with local presence and dedicated support',
      testimonialsTitle: 'What Our Clients Say',
      testimonialsSubtitle: 'Our clients\' trust is our best reference',
      ctaTitle: 'Ready for Certification?',
      ctaSubtitle: 'Contact us today for a free consultation and discover how we can help you achieve ISO certification',
      ctaButton: 'Request Free Quote',
      ctaContact: 'Contact Us'
    },
    
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'Specialized consulting for ISO certifications and HSE compliance',
      learnMore: 'Learn more',
      processTitle: 'Our Process',
      processSubtitle: 'A structured approach to ensure certification success',
      steps: [
        { title: 'Initial Analysis', desc: 'We assess your organization\'s current state and identify intervention areas' },
        { title: 'Planning', desc: 'We develop a detailed action plan with clear timelines and milestones' },
        { title: 'Implementation', desc: 'We support you in system implementation and staff training' },
        { title: 'Internal Audit', desc: 'We conduct internal audits to verify compliance and prepare for certification' },
        { title: 'Certification', desc: 'We accompany you during the certification body\'s audit' },
        { title: 'Continuous Support', desc: 'Ongoing assistance for system maintenance and improvement' }
      ],
      ctaTitle: 'Start Your Certification Journey',
      ctaSubtitle: 'Request a personalized quote or contact us for more information'
    },
    
    // Resources/Blog
    resources: {
      title: 'Resources & Blog',
      subtitle: 'Guides, articles and useful resources on ISO certification and HSE compliance',
      search: 'Search articles...',
      all: 'All',
      readArticle: 'Read article',
      noResults: 'No articles found. Try another search term.',
      faqTitle: 'Frequently Asked Questions',
      faqSubtitle: 'Answers to the most common questions about ISO certification',
      ctaTitle: 'Have More Questions?',
      ctaSubtitle: 'Our team is ready to answer all your questions about ISO certification'
    },
    
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'re here to answer all your questions about ISO certification and HSE compliance',
      formTitle: 'Send Us a Message',
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      selectSubject: 'Select a subject',
      send: 'Send Message',
      sending: 'Sending...',
      subjects: {
        general: 'General Information',
        iso9001: 'ISO 9001 Certification',
        iso45001: 'ISO 45001 Certification',
        iso14001: 'ISO 14001 Certification',
        hse: 'HSE Compliance',
        quote: 'Quote Request',
        other: 'Other'
      },
      infoTitle: 'Contact Information',
      emailLabel: 'Email',
      phoneOffice: 'Office Phone',
      phoneSales: 'Sales / Commercial',
      addressLabel: 'Head Office',
      hoursLabel: 'Office Hours',
      hours: 'Mon - Fri: 9:00 - 18:00\nSat - Sun: Closed',
      serviceAreasTitle: 'Service Areas',
      serviceAreasDesc: 'We operate in the following regions with dedicated local support:'
    },
    
    // Quote Request
    quote: {
      title: 'Request a Quote',
      subtitle: 'Fill out the form to receive a personalized quote within 48 hours',
      companyInfo: 'Company Information',
      companyName: 'Company Name',
      industry: 'Industry',
      selectIndustry: 'Select industry',
      companySize: 'Company Size',
      selectSize: 'Select size',
      timeline: 'Desired Timeline',
      selectTimeline: 'Select timeline',
      contactInfo: 'Contact Details',
      name: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      servicesInterest: 'Services of Interest',
      additionalInfo: 'Additional Information',
      describe: 'Describe your needs',
      submit: 'Request Free Quote',
      submitting: 'Sending...',
      note: 'You will receive a personalized response within 48 hours',
      whatHappens: 'What Happens Next?',
      helpTitle: 'Need Help?',
      helpDesc: 'If you prefer to speak directly with us, we are available:',
      office: 'Office',
      sales: 'Sales',
      industries: {
        manufacturing: 'Manufacturing',
        construction: 'Construction',
        logistics: 'Logistics',
        services: 'Services',
        healthcare: 'Healthcare',
        food: 'Food',
        other: 'Other'
      },
      sizes: {
        '1-10': '1-10 employees',
        '11-50': '11-50 employees',
        '51-250': '51-250 employees',
        '251-500': '251-500 employees',
        '500+': '500+ employees'
      },
      timelines: {
        urgent: 'Within 3 months',
        normal: '3-6 months',
        flexible: '6-12 months',
        exploring: 'Just exploring'
      },
      placeholders: {
        company: 'Your company',
        name: 'Your name',
        email: 'email@company.com',
        phone: '+44 123 456 7890'
      }
    },
    
    // Footer
    footer: {
      tagline: 'Excellence in ISO & HSE Consulting',
      servicesTitle: 'Services',
      resourcesTitle: 'Resources',
      contactTitle: 'Contact',
      blogArticles: 'Blog & Articles',
      guideFaq: 'Guides & FAQ',
      requestQuote: 'Request Quote',
      contactUs: 'Contact Us',
      office: 'Office',
      salesLabel: 'Sales',
      copyright: '© {year} Mallorie Consulting Group. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions'
    },
    
    // Common
    common: {
      required: '*',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      readMore: 'Read more',
      learnMore: 'Learn more',
      contactUs: 'Contact us',
      requestQuote: 'Request Quote'
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};
